import { requestApi } from "../funcitons";

export const CarouselItemsQueries = {
    createItem: async (carousel_cell_id, item) => {
        const response = await requestApi('cells/carousel-items', 'POST', { carousel_cell_id, ...item });
        return response.data;
    }
}